import { render, staticRenderFns } from "./PixiCanvasComponent.vue?vue&type=template&id=412458cc&"
import script from "./PixiCanvasComponent.vue?vue&type=script&lang=ts&"
export * from "./PixiCanvasComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports